export default "__VITE_ASSET__QeI8mJFw__"